import type { FC } from 'react';
import PropTypes from 'prop-types';
import { IconMap } from '../../../icons/Icon.map';
import Play from '../../../icons/icon-components/play';

interface BulletProps {
    assetType: 'IMAGE' | 'VIDEO';
}

export const Bullet: FC<BulletProps> = ({ assetType }: BulletProps): JSX.Element => {
    const props = IconMap.play.sm;

    return (
        <div className="{replace}" data-testid="photo-grid-carousel-view-bullet">
            {assetType === 'IMAGE' ? (
                <div aria-hidden="true" role="button" className="h-3 w-3 rounded-full" />
            ) : (
                <Play
                    width={props.width as string}
                    height={props.height as string}
                    padding={props.padding as string}
                />
            )}
        </div>
    );
};

Bullet.propTypes = {
    assetType: PropTypes.oneOf<'IMAGE' | 'VIDEO'>(['IMAGE', 'VIDEO']).isRequired,
};
